<section>
    <app-header></app-header>
    <div class="container-fluid">
        <div id="home" class="header_hero d-lg-flex align-items-center"
            style="background-image: url('/assets/img/biodata-background.jpg'); background-repeat: no-repeat; background-size: cover;height: 72vh;">
            <div class="mx-5">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="header_hero_content">
                            <span class="text-white paragraph">BioData Solutions develops software to automate
                                bioanalytical processes of data compilation, auditing, and statistical analysis using
                                artificial intelligence technologies and advanced computational techniques.</span>
                            <p class="text-white paragraph">Current modules of Red Thread, BioData's premier software
                                include:</p>
                            <h4 class="text-white section-title"> STATISTICAL ANALYSIS</h4>
                            <ul class="custom-list">
                                <li>ADA Sensitivity Analysis</li>
                                <li>ADA Cutpoint Determination Using Outlier Removal</li>
                                <li>ADA Cutpoint Determination Using Random/Mixed Effects Model</li>
                                <li>PK Regression Parameter Optimization</li>
                            </ul>
                            <h4 class="text-white section-title"> TABLE COMPILATION</h4>
                            <ul class="custom-list">
                                <li> qPCR Table Compilation</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <div class="footer-top">
                <div class="footer-logo">
                    <a href="https://www.bdatasolutions.com/" target="_blank">
                        <img src="assets/img/Biodata-logo.png" alt="BioData Solutions" class="img-fluid" width="200"
                            height="10">
                    </a>
                </div>
                <div class="footer-links">
                    <a href="https://www.bdatasolutions.com/" class="footer-link" target="_blank">BioData Website</a>
                    <a href="https://www.bdatasolutions.com/privacy-policy/" class="footer-link" target="_blank">Privacy
                        Policy</a>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</section>